import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash';

Vue.use(Vuex)

let account = null;
const item = localStorage.getItem('account');
let isAdmin = false;

if (item) {
  try {
    account = JSON.parse(item);
    isAdmin = account.scopes.indexOf('admin') > -1;
  } catch {
    account = null;
  }
}

export default new Vuex.Store({
  state: {
    account,
    titleBar: '',
    titleItems: null as any[] | null,
    appClasses: [] as string[],
    clients: [] as Client[],
    workTypes: [] as any[],
    client: null as any | null,
    isAdmin,
  },
  mutations: {
    CLIENT(state, client) {
      state.client = client;
    },
    TITLE_ITEMS(state, items) {
      state.titleItems = items;
    },
    TITLE_BAR(state, title) {
      state.titleBar = title;
    },
    ACCOUNT(state, account) {
      state.account = account;
      
      if (!account) {
        state.isAdmin = false;
        localStorage.removeItem('account');
        return;
      }

      state.isAdmin = account.scopes.indexOf('admin') > -1;
      localStorage.setItem('account', JSON.stringify(account));
    },
    APP_CLASSES(state, appClasses) {
      state.appClasses = appClasses
    },
    ADD_APP_CLASSES(state, classes: null | string[]) {
      if (!classes || classes.length === 0) { return; }

      if (!state.appClasses) {
        state.appClasses = [];
      }

      classes.forEach(x => {
        if (!state.appClasses.find(y => y == x)) {
          state.appClasses.push(x);
        }
      });
    },
    REMOVE_APP_CLASSES(state, classes: null | string[]) {
      if (!classes || classes.length === 0) { return; }

      classes.forEach(x => {
        const index = state.appClasses.indexOf(x);
        if (index > -1) {
          state.appClasses.slice(index, 1);
        }
      });
    },
    CLIENTS(state, clients) {
      state.clients = _.orderBy(clients, ['name'], ['asc']);
    },
    WORK_TYPES(state, workTypes) {
      state.workTypes = workTypes;
    }
  },
  actions: {
    SET_CLIENT({ commit }, client) {
      commit('CLIENT', client);
    },
    SET_CLIENT_ID({ commit }, clientId) {
      // find client by id
      const client = this.state.clients.find(x => x.id === clientId);
      
      if (!client) {
        return;
      }

      commit('CLIENT', client);
    },
    SET_CLIENTS({ commit }, clients) {
      commit('CLIENTS', clients);
    },
    SET_WORKTYPES({ commit }, workTypes) {
      commit('WORK_TYPES', workTypes);
    }
  },
  getters: {
    isAdmin(state) {
      if (!state.account || !state.account.scopes) {
        return false;
      }

      return state.account.scopes.includes('admin');
    }
  },
  modules: {
  }
})
